import "./Services.css";
import { FaArrowRight, FaCheck } from "react-icons/fa";

const servicesList = [
  {
    badge: "SSIAP 1 / 2 / 3",
    title: "Sécurité Incendie (SSIAP)",
    desc: "Prévention des risques, gestion des systèmes de sécurité incendie et assistance rapide aux personnes.",
    image: "/service-incendie.png",
    points: [
      "Vérification des équipements de secours",
      "Évacuation et premiers secours (SST)",
      "Gestion des alarmes et rondes de sécurité",
    ],
    highlight: false,
  },
  {
    badge: "⭐ Spécialité Phare",
    title: "Agent Cynophile (Maître-Chien)",
    desc: "Binôme homme-chien hautement entraîné pour une dissuasion maximale, le gardiennage et la détection d'intrus.",
    image: "/service-cynophile.png",
    points: [
      "Dissuasion active contre le squat & vol",
      "Sécurisation de vastes périmètres et chantiers",
      "Détection précoce jour et nuit",
    ],
    highlight: true,
  },
  {
    badge: "Contrôle & Filtrage",
    title: "Surveillance & Gardiennage (ADS)",
    desc: "Protection statique de vos locaux commerciaux, résidences, sites industriels et événements.",
    image: "/service-ads.png",
    points: [
      "Contrôle d'accès et filtrage des flux",
      "Accueil et palpation de sécurité",
      "Rondes de fermeture et surveillance préventive",
    ],
    highlight: false,
  },
  {
    badge: "Intervention 24/7",
    title: "Sécurité Mobile & Rondier",
    desc: "Rondes planifiées ou aléatoires et levée de doute sur alarme pour sécuriser vos sites en horaires décalés.",
    image: "/service-mobile.png",
    points: [
      "Intervention rapide sur déclenchement d'alarme",
      "Vérification des issues et points sensibles",
      "Rapport numérique d'intervention immédiat",
    ],
    highlight: false,
  },
];

export default function Services() {
  return (
    <section id="services" className="section services-section">
      <div className="services-header">
        <span className="section-tag">{"//"} PÔLES D'EXPERTISE OPÉRATIONNELLE</span>
        <h2 className="section-title">Nos Prestations de Sécurité</h2>
        <p className="section-subtitle">
          Des solutions complètes de gardiennage et de sûreté déployées par des professionnels certifiés CNAPS.
        </p>
      </div>

      <div className="services-grid">
        {servicesList.map((service, index) => (
          <div
            key={index}
            className={`service-card ${service.highlight ? "highlighted" : ""}`}
          >
            <div className="service-img-wrap">
              <img src={service.image} alt={service.title} loading="lazy" />
              <span className="service-badge">{service.badge}</span>
            </div>

            <div className="service-body">
              <h3>{service.title}</h3>
              <p className="service-desc">{service.desc}</p>

              <ul className="service-points">
                {service.points.map((pt, i) => (
                  <li key={i}>
                    <FaCheck className="pt-icon" /> {pt}
                  </li>
                ))}
              </ul>

              <a href="#contact" className="service-cta">
                Demander ce service <FaArrowRight className="cta-arrow" />
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
